export default __webpack_public_path__ + "static/media/icon-file-image.c72b9f62.svg";